module.exports = __webpack_public_path__ + "static/media/xata-logo.0286e04c.png";